// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TopBarHeader-base__n8MeY{display:flex;align-items:center;justify-content:space-between;height:var(--size-13);padding:var(--size-0) var(--size-4);border-bottom:var(--size-0_25) solid var(--gray-a3)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "TopBarHeader-base__n8MeY"
};
export default ___CSS_LOADER_EXPORT___;
